/**
 * The words on the name roller.
 *
 * A rolled name is its own register, neither chrome nor in-world: see
 * [src/text/AGENTS.md](./AGENTS.md). The words around it are chrome, and this
 * is where they live. The name itself comes from `@/identity/rollPlayerName`.
 */

export const NAME_ROLLER_LABEL = 'You are';
/** On the button, beside the die. */
export const NAME_ROLLER_ACTION = 'Reroll name';
/** What a screen reader hears instead of the die glyph. */
export const NAME_ROLLER_HINT = 'Roll a new name';
